export default __webpack_public_path__ + "static/media/thumbs-down.72eb41e2.svg";